/**
 * Kampagnen und Datensaetze.
 * Grundlage: 03_campaigns.md, 04_contacts_csv.md
 */

export const CAMPAIGN_MODE = {
  /** Gemeinsamer Datenpool fuer alle zugeordneten Caller. */
  POOL: 'pool',
  /** Datensaetze gehoeren einzelnen Callern. */
  ASSIGNED: 'assigned',
} as const;

export type CampaignMode = (typeof CAMPAIGN_MODE)[keyof typeof CAMPAIGN_MODE];

export const PARALLEL_MODE = {
  PER_CALLER: 'per_caller',
  GLOBAL: 'global',
} as const;

export type ParallelMode = (typeof PARALLEL_MODE)[keyof typeof PARALLEL_MODE];

export const SIP_MODE = {
  /** Ein SIP-Zugang fuer alle Caller der Kampagne. */
  GLOBAL: 'global',
  /** Eigener SIP-Zugang je Caller. */
  INDIVIDUAL: 'individual',
} as const;

export type SipMode = (typeof SIP_MODE)[keyof typeof SIP_MODE];

export const SALES_STATUS = {
  NEW: 'new',
  SUCCESSFUL: 'successful',
  CALLBACK: 'callback',
  NOT_INTERESTED: 'not_interested',
} as const;

export type SalesStatus = (typeof SALES_STATUS)[keyof typeof SALES_STATUS];

export const SALES_STATUS_VALUES = Object.values(SALES_STATUS);

export function isSalesStatus(value: unknown): value is SalesStatus {
  return typeof value === 'string' && (SALES_STATUS_VALUES as string[]).includes(value);
}

/**
 * Defaults bei Neuanlage einer Kampagne (03_campaigns.md).
 *
 * Sie stehen zusaetzlich als Spalten-Defaults in der Migration. Hier liegen
 * sie noch einmal, damit die Oberflaeche dieselben Werte anzeigen kann, bevor
 * die Kampagne gespeichert ist.
 *
 * Der globale Mindestabstand fuer Wiederholungsversuche gehoert ausdruecklich
 * NICHT hierher - er ist eine Plattformeinstellung des Hauptadmins.
 */
export const CAMPAIGN_DEFAULTS = {
  campaignMode: CAMPAIGN_MODE.POOL,
  parallelCalls: 2,
  parallelMode: PARALLEL_MODE.PER_CALLER,
  retryCount24h: 2,
  inboundEnabled: false,
  queueEnabled: false,
  queueMaxWaitSeconds: 20,
  recordingDefault: false,
  mailboxDetectionEnabled: true,
  sipMode: SIP_MODE.GLOBAL,
  defaultCountryCode: 'DE',
} as const;

/** Schieberegler 1-5 (05_dialer.md). */
export const PARALLEL_CALLS_MIN = 1;
export const PARALLEL_CALLS_MAX = 5;
/** Ab diesem Wert wird auf das Warteschleifenrisiko hingewiesen. */
export const PARALLEL_CALLS_WARNING_THRESHOLD = 4;

/** Laenge der kurzen, sichtbaren Datensatz-ID. */
export const PUBLIC_ID_LENGTH = 8;
